import apiRequest from "../../../apiRequest";
import { endPoints } from "../../../apis";


export const fetchAdminSettings = async () => {
  //   const params = { page, total, role, search };
  //   return apiRequest.get(endPoints.GET_ADMIN_SETTINGS, params);
  return apiRequest.get(endPoints.GET_ADMIN_SETTINGS);
};

export const updateAdminSettings = async (id, value) => {
  return apiRequest.put(`${endPoints.UPDATE_ADMIN_SETTINGS}/${id}`, value);
};
